module.exports = __webpack_public_path__ + "img/img18.9b32d21c.png";